/** return the list of routes used
@return { Object } - containing all the routes for our core, routes for specific apps are not here
*/
export const routeList = {
	/* ***********************************************
	*												 *
	*			 Non-authenticated routes			 *
	*												 *
	*********************************************** */
	DESIGN_SHOWROOM_PATH: '/designShowroom',
	DESIGN_SHOWROOM_NAME: 'DesignShowroom',
	DESIGN_SHOWROOM_FIRST_ENTRY: '#buttonsComponents#card',
	LOGIN_PATH: '/',
    LOGIN_NAME: 'Login',
	AUTHORIZE_SESSION_PATH: '/authorizeSession',
	AUTHORIZE_SESSION_NAME: 'AuthorizeSession',
	NON_AUTHENTICATED_JOIN_PATH: '/join',
	NON_AUTHENTICATED_JOIN_NAME: 'Join',
	NON_AUTHENTICATED_JOIN_CREATE_ACCOUNT_PATH: '/join/createAccount',
	NON_AUTHENTICATED_JOIN_CREATE_ACCOUNT_NAME: 'JoinCreateAccount',
	NON_AUTHENTICATED_JOIN_SELF_ADHESION_PATH: '/join/selfAdhesion',
	NON_AUTHENTICATED_JOIN_SELF_ADHESION_NAME: 'JoinSelfAdhesion',
    NON_AUTHENTICATED_PRE_ACTIVE_MODE_PATH: '/preActiveMode',
    NON_AUTHENTICATED_PRE_ACTIVE_MODE_NAME: 'PreActiveMode',
    NON_AUTHENTICATED_PRE_ACTIVE_MODE_RECOVER_CREDENTIALS_PATH: '/preActiveModeRecoverCredentials',
    NON_AUTHENTICATED_PRE_ACTIVE_MODE_RECOVER_CREDENTIALS_NAME: 'PreActiveModeRecoverCredentials',
	RECOVER_CREDENTIALS_PATH: '/recoverCredentials',
	RECOVER_CREDENTIALS_NAME: 'RecoverCredentials',
	NON_AUTHENTICATED_AGENCIES_PATH: '/nonAuthenticatedAgencies',
	NON_AUTHENTICATED_AGENCIES_NAME: 'NonAuthenticatedAgencies',
	NON_AUTHENTICATED_CONTACTS_PATH: '/nonAuthenticatedContacts',
	NON_AUTHENTICATED_CONTACTS_NAME: 'NonAuthenticatedContacts',
	NON_AUTHENTICATED_EXCHANGES_PATH: '/nonAuthenticatedExchanges',
	NON_AUTHENTICATED_EXCHANGES_NAME: 'NonAuthenticatedExchanges',
	NON_AUTHENTICATED_TICKETS_PATH: '/nonAuthenticatedTickets',
	NON_AUTHENTICATED_TICKETS_NAME: 'NonAuthenticatedTickets',
	/* ***********************************************
	*												 *
	*				Authenticated routes			 *
	*												 *
	*********************************************** */
	HOME_PATH: '/home',
	HOME_NAME: 'Home',
	HOME_MOBILE_PATH: '/mobileMenuhome',
	HOME_MOBILE_NAME: 'MobileMenuhome',
	/* ***********************************************
	*												 *
	*   	   Initial Actions + Validations	     *
	*												 *
	*********************************************** */
	INITIAL_ACTIONS_VALIDATE_SESSION_PATH: '/validateSession',
	INITIAL_ACTIONS_VALIDATE_SESSION_NAME: 'ValidateSession',
	INITIAL_ACTIONS_FIRST_LOGIN_PATH: '/firstLogin',
	INITIAL_ACTIONS_FIRST_LOGIN_NAME: 'FirstLogin',
	INITIAL_ACTIONS_CHOOSE_DEFAULT_CONTRACT_ACCOUNT_GROUP_PATH: '/chooseDefaultContractAccountGroup',
	INITIAL_ACTIONS_CHOOSE_DEFAULT_CONTRACT_ACCOUNT_GROUP_NAME: 'ChooseDefaultContractAccountGroup',
    INITIAL_ACTIONS_SHOW_SECURE_ASSOCIATION_ENROLLMENT_PATH: '/initialSecureAssociationEnrollment',
    INITIAL_ACTIONS_SHOW_SECURE_ASSOCIATION_ENROLLMENT_NAME: 'InitialSecureAssociationEnrollment',
	/* ***********************************************
	*												 *
	*				     APPROVALS			 		 *
	*												 *
	*********************************************** */
	APPROVALS_BASE_PATH: '/approvals',
	APPROVALS_PENDING_SIGNATURE_PATH: '/approvals/pendingSignature',
	APPROVALS_PENDING_SIGNATURE_NAME: 'ApprovalsPendingSignature',
	APPROVALS_OPERATORS_PATH: '/approvals/operators',
	APPROVALS_OPERATORS_NAME: 'ApprovalsOperators',
	APPROVALS_OPERATORS_CREATE_PATH: '/approvals/operators/create',
	APPROVALS_OPERATORS_CREATE_NAME: 'ApprovalsOperatorsCreate',
	APPROVALS_OPERATORS_EDIT_PATH: '/approvals/operators/edit',
	APPROVALS_OPERATORS_EDIT_NAME: 'ApprovalsOperatorsEdit',
	APPROVALS_OPERATORS_DELETE_PATH: '/approvals/operators/delete',
	APPROVALS_OPERATORS_DELETE_NAME: 'ApprovalsOperatorsDelete',
	APPROVALS_OPERATORS_BLOCK_PATH: '/approvals/operators/block',
	APPROVALS_OPERATORS_BLOCK_NAME: 'ApprovalsOperatorsBlock',
	APPROVALS_OPERATORS_UNBLOCK_PATH: '/approvals/operators/unblock',
	APPROVALS_OPERATORS_UNBLOCK_NAME: 'ApprovalsOperatorsUnblock',
	APPROVALS_SIGNED_PATH: '/approvals/signed',
	APPROVALS_SIGNED_NAME: 'ApprovalsSigned',
	/* ***********************************************
	*												 *
	*    		     COMPANY PAYMENTS			     *
	*												 *
	*********************************************** */
	COMPANY_PAYMENTS_BASE_PATH: '/companyPayments',
	COMPANY_PAYMENTS_REQUEST_TPA_PATH: '/companyPayments/requestTPA',
	COMPANY_PAYMENTS_REQUEST_TPA_NAME: 'CompanyPaymentsRequestTPA',
	COMPANY_PAYMENTS_REQUEST_TPA_BAI_PATH: '/companyPayments/requestTPA/BAI_tpaBAI',
	COMPANY_PAYMENTS_REQUEST_TPA_BAI_NAME: 'CompanyPaymentsRequestTPABAI',
	COMPANY_PAYMENTS_BAI_PAGA_MERCHANT_PATH: '/companyPayments/baiPagaMerchant',
	COMPANY_PAYMENTS_BAI_PAGA_MERCHANT_NAME: 'CompanyPaymentsBaiPagaMerchant',
	COMPANY_PAYMENTS_TPA_REQUESTS_LIST_PATH: '/companyPayments/TPARequestsList',
	COMPANY_PAYMENTS_TPA_REQUESTS_LIST_NAME: 'CompanyPaymentsTPARequestsList',
	/* ***********************************************
	*                     ACCOUNTS                   *
	*********************************************** */
	ACCOUNTS_BASE_PATH: '/accounts',
	ACCOUNTS_BALANCES_AND_MOVEMENTS_PATH: '/accounts/balancesAndMovements',
	ACCOUNTS_BALANCES_AND_MOVEMENTS_NAME: 'AccountsBalancesAndMovements',
	ACCOUNTS_PATRIMONY_PATH: '/accounts/patrimony',
	ACCOUNTS_PATRIMONY_NAME: 'AccountsPatrimony',
	ACCOUNTS_CASHFLOW_PATH: '/accounts/cashflow',
	ACCOUNTS_CASHFLOW_NAME: 'AccountsCashflow',
	ACCOUNTS_EXTRACTS_PATH: '/accounts/extracts',
	ACCOUNTS_EXTRACTS_NAME: 'AccountsExtracts',
	ACCOUNTS_INVOICES_PATH: '/accounts/invoices',
	ACCOUNTS_INVOICES_NAME: 'AccountsInvoices',
	ACCOUNTS_DETAILS_PATH: '/accounts/details',
	ACCOUNTS_DETAILS_NAME: 'AccountsDetails',
	ACCOUNTS_WALLET_PATH: '/accounts/wallet',
	ACCOUNTS_WALLET_NAME: 'AccountsWallet',
	ACCOUNTS_WALLET_CREATE_PATH: '/accounts/wallet/create',
	ACCOUNTS_WALLET_CREATE_NAME: 'AccountsWalletCreate',
	ACCOUNTS_WALLET_REGIST_PATH: '/accounts/wallet/regist',
	ACCOUNTS_WALLET_REGIST_NAME: 'AccountsWalletRegist',
	ACCOUNTS_WALLET_LIMITS_PATH: '/accounts/wallet/limits',
	ACCOUNTS_WALLET_LIMITS_NAME: 'AccountsWalletLimits',
	ACCOUNTS_VISIBLE_PATH: '/accounts/visible',
	ACCOUNTS_VISIBLE_NAME: 'AccountsVisible',
	/* ***********************************************
	*                    TRANSFERS                   *
	*********************************************** */
	TRANSFERS_BASE_PATH: '/transfers',
	TRANSFERS_NACIONAL_PATH: '/transfers/nacional',
	TRANSFERS_NACIONAL_NAME: 'TransfersNacional',
	TRANSFERS_INTERNATIONAL_PATH: '/transfers/international',
	TRANSFERS_INTERNATIONAL_NAME: 'Transfersinternational',
    TRANSFERS_INTERNATIONAL_CORPORATE_PATH: '/transfers/internationalCorporate',
    TRANSFERS_INTERNATIONAL_CORPORATE_NAME: 'TransfersInternationalCorporate',
	TRANSFERS_INSTANT_BAI_PATH: '/transfers/instantBAI',
	TRANSFERS_INSTANT_BAI_NAME: 'TransfersInstantBAI',
	TRANSFERS_KWIK_PATH: '/transfers/kwik',
	TRANSFERS_KWIK_NAME: 'TransfersKwik',
	TRANSFERS_KWIK_TRANSFER_PATH: '/transfers/kwik/transfer',
	TRANSFERS_KWIK_TRANSFER_NAME: 'TransfersKwikTransfer',
	TRANSFERS_KWIK_MANAGE_ACCOUNTS_PATH: '/transfers/kwik/manageAccounts',
	TRANSFERS_KWIK_MANAGE_ACCOUNTS_NAME: 'TransfersKwikManageAccounts',
	TRANSFERS_REQUEST_NAHORA_PATH: '/transfers/requestNaHora',
	TRANSFERS_REQUEST_NAHORA_NAME: 'TransfersRequestNaHora',
	TRANSFERS_HISTORY_PATH: '/transfers/history',
	TRANSFERS_HISTORY_NAME: 'TransfersHistory',
	TRANSFERS_HISTORY_INTERNATIONAL_PATH: '/transfers/history/international',
	TRANSFERS_HISTORY_INTERNATIONAL_NAME: 'TransfersHistoryinternational',
	TRANSFERS_HISTORY_NACIONAL_PATH: '/transfers/history/nacional',
	TRANSFERS_HISTORY_NACIONAL_NAME: 'TransfersHistoryNacional',
	TRANSFERS_HISTORY_NAHORA_PATH: '/transfers/history/naHora',
	TRANSFERS_HISTORY_NAHORA_NAME: 'TransfersHistoryNaHora',
	TRANSFERS_PERIODIC_PATH: '/transfers/periodic',
	TRANSFERS_PERIODIC_NAME: 'TransfersPeriodic',
	TRANSFERS_PERIODIC_EDIT_PATH: '/transfers/periodic/edit',
	TRANSFERS_PERIODIC_EDIT_NAME: 'TransfersPeriodicEdit',
	TRANSFERS_BENEFICIARIES_PATH: '/transfers/beneficiaries',
	TRANSFERS_BENEFICIARIES_NAME: 'TransfersBeneficiaries',
	TRANSFERS_BENEFICIARIES_CREATE_PATH: '/transfers/beneficiaries/create',
	TRANSFERS_BENEFICIARIES_CREATE_NAME: 'TransfersBeneficiariesCreate',
	TRANSFERS_BENEFICIARIES_EDIT_PATH: '/transfers/beneficiaries/edit',
	TRANSFERS_BENEFICIARIES_EDIT_NAME: 'TransfersBeneficiariesEdit',
	TRANSFERS_REQUESTS_PATH: '/transfers/requests',
	TRANSFERS_REQUESTS_NAME: 'TransfersRequests',
	TRANSFERS_REQUESTS_INTERNATIONAL_PATH: '/transfers/requests/international',
	TRANSFERS_REQUESTS_INTERNATIONAL_NAME: 'TransfersRequestsInternational',
    TRANSFERS_REQUESTS_INTERNATIONAL_CORPORATE_PATH: '/transfers/requests/internationalCorporate',
    TRANSFERS_REQUESTS_INTERNATIONAL_CORPORATE_NAME: 'TransfersRequestsInternationalCorporate',
	TRANSFERS_REQUESTS_NACIONAL_PATH: '/transfers/requests/nacional',
	TRANSFERS_REQUESTS_NACIONAL_NAME: 'TransfersRequestsNacional',
	TRANSFERS_REQUESTS_NACIONAL_NAHORA_SENT_PATH: '/transfers/requests/nacional/naHoraSent',
	TRANSFERS_REQUESTS_NACIONAL_NAHORA_SENT_NAME: 'TransfersRequestsNacionalNaHoraSent',
	TRANSFERS_REQUESTS_NACIONAL_NAHORA_RECEIVED_PATH: '/transfers/requests/nacional/naHoraReceived',
	TRANSFERS_REQUESTS_NACIONAL_NAHORA_RECEIVED_NAME: 'TransfersRequestsNacionalNaHoraReceived',
	/* ***********************************************
	*                    PAYMENTS                    *
	*********************************************** */
	PAYMENTS_BASE_PATH: '/payments',
	PAYMENTS_BAI_PAGA_PATH: '/payments/baiPaga',
	PAYMENTS_BAI_PAGA_NAME: 'PaymentsBaiPaga',
	PAYMENTS_BATCHFILE_PATH: '/payments/batchfile',
	PAYMENTS_BATCHFILE_NAME: 'PaymentsBatchfile',
	PAYMENTS_BATCHFILE_NEW_PAYMENT_PATH: '/payments/batchfile/newPayment',
	PAYMENTS_BATCHFILE_NEW_PAYMENT_NAME: 'PaymentsBatchfileNewPayment',
	PAYMENTS_SERVICES_PATH: '/payments/services',
	PAYMENTS_SERVICES_NAME: 'PaymentsServices',
	PAYMENTS_SERVICES_FLOW_EMIS_REFERENCE_PATH: '/payments/services/emisReference',
	PAYMENTS_SERVICES_FLOW_EMIS_REFERENCE_NAME: 'PaymentsServicesEmisReference',
	PAYMENTS_SERVICES_FLOW_EMIS_SPECIAL_PATH: '/payments/services/emisSpecial',
	PAYMENTS_SERVICES_FLOW_EMIS_SPECIAL_NAME: 'PaymentsServicesEmisSpecial',
	PAYMENTS_SERVICES_FLOW_EMIS_REFILL_PATH: '/payments/services/emisRefill',
	PAYMENTS_SERVICES_FLOW_EMIS_REFILL_NAME: 'PaymentsServicesEmisRefill',
	PAYMENTS_SERVICES_FLOW_EMIS_VOUCHER_PATH: '/payments/services/emisVoucher',
	PAYMENTS_SERVICES_FLOW_EMIS_VOUCHER_NAME: 'PaymentsServicesEmisVoucher',
	PAYMENTS_SERVICES_FLOW_UNITEL_PATH: '/payments/services/unitel',
	PAYMENTS_SERVICES_FLOW_UNITEL_NAME: 'PaymentsServicesUnitel',
	PAYMENTS_SERVICES_FLOW_MINFIN_PATH: '/payments/services/minfin_bai',
	PAYMENTS_SERVICES_FLOW_MINFIN_NAME: 'PaymentsServicesMinfin_bai',
	PAYMENTS_MINFIN_PATH: '/payments/state',
    PAYMENTS_MINFIN_NAME: 'PaymentsState',
    PAYMENTS_EMIS_REFERENCE_PATH: '/payments/reference',
    PAYMENTS_EMIS_REFERENCE_NAME: 'PaymentsReference',
    PAYMENTS_EKWANZA_PATH: '/payments/eKwanza',
    PAYMENTS_EKWANZA_NAME: 'PaymentsEKwanza',
	PAYMENTS_WALLET_PATH: '/payments/wallet',
	PAYMENTS_WALLET_NAME: 'PaymentsWallet',
	PAYMENTS_REQUESTS_PATH: '/payments/requests',
	PAYMENTS_REQUESTS_NAME: 'PaymentsRequests',
	PAYMENTS_REQUESTS_BAI_PAGA_PATH: '/payments/requests/baiPaga',
	PAYMENTS_REQUESTS_BAI_PAGA_NAME: 'PaymentsRequestsbaiPaga',
	PAYMENTS_REQUESTS_BAI_PAGA_PAY_PATH: '/payments/requests/baiPaga/pay',
	PAYMENTS_REQUESTS_BAI_PAGA_PAY_NAME: 'PaymentsRequestsbaiPagaPay',
	PAYMENTS_REQUESTS_EKWANZA_PATH: '/payments/requests/eKwanza',
	PAYMENTS_REQUESTS_EKWANZA_NAME: 'PaymentsRequestsEKwanza',
	PAYMENTS_HISTORY_PATH: '/payments/history',
	PAYMENTS_HISTORY_NAME: 'PaymentsHistory',
	/* ***********************************************
	*                     CARDS                      *
	*********************************************** */
	CARDS_BASE_PATH: '/cards',
	CARDS_CARDLESS_WITHDRAW_PATH: '/cards/cardlessWithdraw',
	CARDS_CARDLESS_WITHDRAW_NAME: 'CardsCardlessWithdraw',
	CARDS_CARDLESS_WITHDRAW_GENERATE_CODE_PATH: '/cards/cardlessWithdraw/generateCode',
	CARDS_CARDLESS_WITHDRAW_GENERATE_CODE_NAME: 'CardsCardlessWithdrawGenerateCode',
	CARDS_CARDLESS_WITHDRAW_MY_CODES_PATH: '/cards/cardlessWithdraw/myCodes',
	CARDS_CARDLESS_WITHDRAW_MY_CODES_NAME: 'CardsCardlessWithdrawMyCodes',
	CARDS_CONSULT_PATH: '/cards/consult',
	CARDS_CONSULT_NAME: 'CardsConsult',
	CARDS_CANCEL_PATH: '/cards/consult/cancel',
	CARDS_CANCEL_NAME: 'CardsCancel',
	CARDS_CHANGE_PAYMENT_PATH: '/cards/consult/changePayment',
	CARDS_CHANGE_PAYMENT_NAME: 'CardsChangePayment',
	CARDS_ANTICIPATE_PAYMENT_PATH: '/cards/consult/anticipatePayment',
	CARDS_ANTICIPATE_PAYMENT_NAME: 'CardsAnticipatePayment',
	CARDS_BLOCK_PATH: '/cards/consult/block',
	CARDS_BLOCK_NAME: 'CardsBlock',
	CARDS_LIMITS_PATH: '/cards/consult/limits',
	CARDS_LIMITS_NAME: 'CardsLimits',
    CARDS_HISTORY_PATH: '/cards/history',
    CARDS_HISTORY_NAME: 'CardsHistory',
	/* Transfer */
	CARDS_TRANSFERS_FLEX_PATH: '/cards/consult/transfer/flex',
	CARDS_TRANSFERS_FLEX_NAME: 'CardsTransferFlex',
	/* Charge */
	CARDS_CHARGE_DIRECT_KAMBA_PATH: '/cards/consult/charge/kambaDirect',
	CARDS_CHARGE_DIRECT_KAMBA_NAME: 'CardsChargeKambaDirect',
	CARDS_CHARGE_FLEX_PATH: '/cards/consult/charge/flex',
	CARDS_CHARGE_FLEX_NAME: 'CardsChargeFlex',
	CARDS_CHARGE_VIRTUAL_PATH: '/cards/consult/charge/virtual',
	CARDS_CHARGE_VIRTUAL_NAME: 'CardsChargeVirtual',
	CARDS_CHARGE_MULTICAIXA_PATH: '/cards/consult/charge/Multicaixa',
	CARDS_CHARGE_MULTICAIXA_NAME: 'CardsChargeMulticaixa',
	CARDS_ACTIVATE_PATH: '/cards/activate',
	CARDS_ACTIVATE_NAME: 'CardsActivate',
	/* Requests */
	CARDS_REQUEST_PATH: '/cards/request',
	CARDS_REQUEST_NAME: 'CardsRequest',
	CARDS_REQUEST_CARD_GENERIC_PATH: '/cards/request/genericRequest',
	CARDS_REQUEST_CARD_GENERIC_NAME: 'CardsRequestGenericRequest',
	CARDS_REQUEST_CARD_CVISA_VIRT_PATH: '/cards/request/virtualCard',
	CARDS_REQUEST_CARD_CVISA_VIRT_NAME: 'CardsRequestVirtualCard',
	/* Batchfile */
	CARDS_BATCHFILE_PATH: '/cards/batchfile',
	CARDS_BATCHFILE_NAME: 'CardsBatchfile',
	CARDS_BATCHFILE_CONSULT_FLEX_PATH: '/cards/batchfile/consult/flex',
	CARDS_BATCHFILE_CONSULT_FLEX_NAME: 'CardsBatchfileConsultFlex',
	CARDS_BATCHFILE_CONSULT_KAMBA_PATH: '/cards/batchfile/consult/kamba',
	CARDS_BATCHFILE_CONSULT_KAMBA_NAME: 'CardsBatchfileConsultKamba',
	CARDS_BATCHFILE_CONSULT_MULTICAIXA_PATH: '/cards/batchfile/consult/multicaixa',
	CARDS_BATCHFILE_CONSULT_MULTICAIXA_NAME: 'CardsBatchfileConsultMulticaixa',
	CARDS_BATCHFILE_NEW_CHARGE_PATH: '/cards/batchfile/newCharge',
	CARDS_BATCHFILE_NEW_CHARGE_NAME: 'CardsBatchfileNewCharge',
	CARDS_BATCHFILE_NEW_CHARGE_FLEX_PATH: '/cards/batchfile/newCharge/flex',
	CARDS_BATCHFILE_NEW_CHARGE_FLEX_NAME: 'CardsBatchfileNewChargeFlex',
	CARDS_BATCHFILE_NEW_CHARGE_KAMBA_PATH: '/cards/batchfile/newCharge/kamba',
	CARDS_BATCHFILE_NEW_CHARGE_KAMBA_NAME: 'CardsBatchfileNewChargeKamba',
	CARDS_BATCHFILE_NEW_CHARGE_MULTICAIXA_PATH: '/cards/batchfile/newCharge/multicaixa',
	CARDS_BATCHFILE_NEW_CHARGE_MULTICAIXA_NAME: 'CardsBatchfileNewChargeMulticaixa',
	/* ***********************************************
	*                     CREDITS                    *
	*********************************************** */
	CREDITS_BASE_PATH: '/credits',
	CREDITS_MY_CREDITS_PATH: '/credits/myCredits',
	CREDITS_MY_CREDITS_NAME: 'CreditsMyCredits',
	CREDITS_MY_CREDITS_AMORTIZATION_PATH: '/credits/myCredits/amortization',
	CREDITS_MY_CREDITS_AMORTIZATION_NAME: 'CreditsMyCreditsAmortization',
	CREDITS_CREDIT_SOLUTIONS_PATH: '/credits/creditSolutions',
	CREDITS_CREDIT_SOLUTIONS_NAME: 'CreditsCreditSolutions',
	CREDIT_CREDIT_SOLUTIONS_SUBSCRIBE_PRODUCT_PATH: '/credit/creditSolutions/subscribeProduct',
	CREDIT_CREDIT_SOLUTIONS_SUBSCRIBE_PRODUCT_NAME: 'CreditCreditSolutionsSubscribeProduct',
	CREDITS_HISTORY_PATH: '/credits/history',
	CREDITS_HISTORY_NAME: 'CreditsHistory',
	/* ***********************************************
	*                     SAVINGS                    *
	*********************************************** */
	SAVINGS_BASE_PATH: '/savings',
	SAVINGS_MY_SAVINGS_PATH: '/savings/mySavings',
	SAVINGS_MY_SAVINGS_NAME: 'SavingsMySavings',
	SAVINGS_MY_SAVINGS_PORTFOLIO_PATH: '/savings/mySavings/portfolio',
	SAVINGS_MY_SAVINGS_PORTFOLIO_NAME: 'SavingsMySavingsPortfolio',
	SAVINGS_MY_SAVINGS_PORTFOLIO_CHARGE_PATH: '/savings/mySavings/portfolio/charge',
	SAVINGS_MY_SAVINGS_PORTFOLIO_CHARGE_NAME: 'SavingsMySavingsCharge',
	SAVINGS_MY_SAVINGS_PORTFOLIO_MOBILIZE_PATH: '/savings/mySavings/portfolio/mobilize',
	SAVINGS_MY_SAVINGS_PORTFOLIO_MOBILIZE_NAME: 'SavingsMySavingsMobilize',
	SAVINGS_MY_SAVINGS_PIGGY_BANK_PATH: '/savings/mySavings/piggyBank',
	SAVINGS_MY_SAVINGS_PIGGY_BANK_NAME: 'SavingsMySavingsPiggyBank',
	SAVINGS_PRODUCTS_PATH: '/savings/products',
	SAVINGS_PRODUCTS_NAME: 'SavingsProducts',
	SAVINGS_PRODUCTS_CONSTITUTE_PATH: '/savings/products/constitute',
	SAVINGS_PRODUCTS_CONSTITUTE_NAME: 'SavingsProductsConstitute',
	SAVINGS_HISTORY_PATH: '/transfers/history',
	SAVINGS_HISTORY_NAME: 'TransfersHistory',
	SAVINGS_HISTORY_PORTFOLIO_PATH: '/savings/history/portfolio',
	SAVINGS_HISTORY_PORTFOLIO_NAME: 'SavingsHistoryPortfolio',
	SAVINGS_HISTORY_OBJECTIVES_PATH: '/savings/history/objectives',
	SAVINGS_HISTORY_OBJECTIVES_NAME: 'SavingsHistoryObjectives',
	/* ***********************************************
	*                 BANKASSURANCE                  *
	*********************************************** */
	BANKASSURANCE_BASE_PATH: '/bankassurance',
	BANKASSURANCE_SUBSCRIBE_PATH: '/bankassurance/subscribe',
	BANKASSURANCE_SUBSCRIBE_NAME: 'BankassuranceSubscribe',
	BANKASSURANCE_SUBSCRIBE_TRAVEL_PATH: '/bankassurance/subscribe/travel',
	BANKASSURANCE_SUBSCRIBE_TRAVEL_NAME: 'BankassuranceSubscribeTravel',
	BANKASSURANCE_SUBSCRIBE_AUTO_PATH: '/bankassurance/subscribe/auto',
	BANKASSURANCE_SUBSCRIBE_AUTO_NAME: 'BankassuranceSubscribeAuto',
	BANKASSURANCE_SUBSCRIBE_HEALTH_PATH: '/bankassurance/subscribe/health',
	BANKASSURANCE_SUBSCRIBE_HEALTH_NAME: 'BankassuranceSubscribeHealth',
	BANKASSURANCE_POLICIES_PATH: '/bankassurance/policies',
	BANKASSURANCE_POLICIES_NAME: 'BankassurancePolicies',
	/* ***********************************************
	*                     Contacts                  *
	*********************************************** */
	CONTACTS_PATH: '/contacts',
	CONTACTS_NAME: 'Contacts',
	/* ***********************************************
	*                     Exchanges                  *
	*********************************************** */
	EXCHANGES_PATH: '/exchanges',
	EXCHANGES_NAME: 'Exchanges',
	/* ***********************************************
	*                     Agencies                  *
	*********************************************** */
	AGENCIES_PATH: '/agencies',
	AGENCIES_NAME: 'Agencies',
	/* ***********************************************
	*                     Favorites                  *
	*********************************************** */
	FAVORITES_PATH: '/favorites',
	FAVORITES_NAME: 'Favorites',
	/* ***********************************************
	*                     User Area                  *
	*********************************************** */
	USER_AREA_BASE_PATH: '/userArea',
	USER_AREA_PROFILE_PATH: '/userArea/profile',
	USER_AREA_PROFILE_NAME: 'UserAreaProfile',
	USER_AREA_DEFINITIONS_PATH: '/userArea/definitions',
	USER_AREA_DEFINITIONS_NAME: 'UserAreaDefinitions',
	USER_AREA_DEFINITIONS_ACTIVE_CHANNELS_PATH: '/userArea/definitions/activeChannels',
	USER_AREA_DEFINITIONS_ACTIVE_CHANNELS_NAME: 'UserAreaDefinitionsactiveChannels',
	USER_AREA_DEFINITIONS_PASSWORD_CHANGE_PATH: '/userArea/definitions/passwordChange',
	USER_AREA_DEFINITIONS_PASSWORD_CHANGE_NAME: 'UserAreaDefinitionsPasswordChange',
	USER_AREA_DEFINITIONS_FRIENDLY_USERNAME_PATH: '/userArea/definitions/friendlyUsername',
	USER_AREA_DEFINITIONS_FRIENDLY_USERNAME_NAME: 'UserAreaDefinitionsFriendlyUsername',
	USER_AREA_DEFINITIONS_ACCOUNTS_GROUPS_PATH: '/userArea/definitions/accountGroups',
	USER_AREA_DEFINITIONS_ACCOUNTS_GROUPS_NAME: 'UserAreaDefinitionsAccountGroups',
	USER_AREA_DEFINITIONS_HISTORY_PATH: '/userArea/definitions/history',
	USER_AREA_DEFINITIONS_HISTORY_NAME: 'UserAreaDefinitionsHistory',
    USER_AREA_DEFINITIONS_SECURE_ASSOCIATION_ENROLLMENT_PATH: '/userArea/definitions/secureAssociationEnrollment',
    USER_AREA_DEFINITIONS_SECURE_ASSOCIATION_ENROLLMENT_NAME: 'userAreaDefinitionssecureAssociationEnrollment',
    USER_AREA_DEFINITIONS_NOTIFICATIONS_PATH: '/userArea/definitions/notifications',
    USER_AREA_DEFINITIONS_NOTIFICATIONS_NAME: 'userAreaDefinitionsNotifications'
}
